module.exports = __webpack_public_path__ + "static/favicon_users-3567a85a792c116a3ebc247454ef4472.ico";